export interface SubscriberEvent {
  type: string
  [key: string]: string
}

declare global {
  interface Window {
    pushHost: string | null
  }
}

export default class Subscriber {
  url?: string
  fragment: DocumentFragment
  websocket?: WebSocket

  constructor(channel: string) {
    this.fragment = document.createDocumentFragment()

    if (!window.pushHost) {
      return
    }

    this.url = `wss://${window.pushHost}/subscribe-ws/${channel}`

    this.websocket = new WebSocket(this.url)
    this.websocket.onmessage = this.handleMessage
  }

  handleMessage = (event: MessageEvent): void => {
    const data = JSON.parse(event.data) as SubscriberEvent

    if (data && data.type) {
      const messageEvent = new CustomEvent(data.type, {
        detail: data,
      })
      this.fragment.dispatchEvent(messageEvent)
    }
  }

  addEventListener = (type: string, listener: EventListener): void => {
    this.fragment.addEventListener(type, listener)
  }

  removeEventListener = (type: string, listener: EventListener): void => {
    this.fragment.removeEventListener(type, listener)
  }
}
